import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.scss'

const Chips = ({ children, selected, className, ...props }) => {
  let additionalClass = ''
  if (selected !== null) {
    if (selected) {
      additionalClass += styles.selected
    } else {
      additionalClass += styles.unselected
    }
  }

  return (
    <div
      className={`${styles.chips} ${additionalClass}`}
      {...props}
    >
      {children}
    </div>
  )
}

Chips.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.array]).isRequired,
  className: PropTypes.object,
  selected: PropTypes.bool,
}

Chips.defaultProps = {
  selected: null,
  className: {},
}

export default Chips
